// extracted by mini-css-extract-plugin
var _1 = "PageStaffProfile__content--Pq8BE OfficeGeneral__sectionContent--CCJVl";
var _2 = "PageStaffProfile__main--laR_n";
var _3 = "PageStaffProfile__title--WN_E7 OfficeGeneral__robotoSlab--GdBSw OfficeGeneral__robotoMedium--itFSf CoreGeneral__robotoMedium--xrjYk OfficeGeneral__textSizeH--ahdk6 CoreGeneral__textSizeH--lhcPc";
export { _1 as "content", _2 as "main", _3 as "title" }
